import React, { useState, useEffect, useRef } from "react";
import '../css/detail.css';
import sliceIntoChunks from "../untils";
import ModalDetailDesktop from "../components/ModalDetailDesktop";
import { supabase } from '../supabaseClient';
import { v4 } from 'uuid';

function DetailPK() {

    const [dataList, setDataList] = useState([
        { stt: 1, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 2, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 3, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 4, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 5, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 6, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 7, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 8, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 9, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 10, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 11, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 12, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 13, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 14, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 15, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 16, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 17, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 18, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 19, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 20, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 21, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 22, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 23, id: v4(), img1: "", img2: "", name: 'CHF' },
        { stt: 24, id: v4(), img1: "", img2: "", name: 'CHF' },
    ])

    const windowWidth = useRef(window.innerWidth);
    const windowHeight = useRef(window.innerHeight);

    const [value, setValue] = useState(4);
    const [select, setSelect] = useState(dataList[0]);

    const patchToStt = (patch) => Number(String(patch).replace('img', '')) + 1

    const fetchImages = async (patch) => {
        const { data, error } = await supabase.storage
            .from('images_PK')
            .list(patch, { limit: 3 })

        if (error) console.error('Lỗi lấy ảnh:', error.message)
        else {
            let urls = data.map((img) =>
                supabase.storage
                    .from('images_PK')
                    .getPublicUrl(`${patch}/${img.name}`).data.publicUrl
            )
            urls = urls.filter(url => url.includes('.emptyFolderPlaceholder') === false)

            const stt = patchToStt(patch)

            setDataList(prev => (prev || []).map(item => {
                if (item?.stt === stt) {
                    return {
                        ...item,
                        img1: urls[0] || item.img1,
                        img2: urls[1] || item.img2,
                    }
                }
                return item
            }))
        }
    }

    useEffect(() => {
        window.scrollTo(0, 0);
        (async () => {

            await fetchImages('img0')

            await fetchImages('img1')
    
            await fetchImages('img2')
    
            await fetchImages('img3')
    
            await fetchImages('img4')
    
            await fetchImages('img5')
    
            await fetchImages('img6')
    
            await fetchImages('img7')
    
            await fetchImages('img8')
    
            await fetchImages('img9')
    
            await fetchImages('img10')
    
            await fetchImages('img11')
    
            await fetchImages('img12')
    
            await fetchImages('img13')
    
            await fetchImages('img14')
    
            await fetchImages('img15')
    
            await fetchImages('img16')
    
            await fetchImages('img17')
    
            await fetchImages('img18')
    
            await fetchImages('img19')
    
            await fetchImages('img20')
    
            await fetchImages('img21')
    
            await fetchImages('img22')
    
            await fetchImages('img23')
        })();

    }, [])

    console.log('data111', dataList);

    function checkMediaQuery() {
        // If the inner width of the window is greater then 768px
        if (window.innerWidth >= 768 && window.innerWidth <= 990) {
            // Then log this message to the console
            console.log('Media Query Matched!')
            setValue(3)
        } else {
            setValue(4)
        }
    }

    useEffect(() => {
        window.addEventListener('resize', checkMediaQuery);
        return () => {
            window.removeEventListener('resize', checkMediaQuery);
        }
    },)

    const renderGrid = () => {
        console.log('data renderGrid', dataList);
        if (dataList) {
            const resArr = sliceIntoChunks(dataList, value);
            return <div>{resArr.map((e, i) => {
                return <div className="d-flex row" key={i}>{e.map((ele, index) => {
                    return (<div
                        onClick={() => {
                            setSelect(ele)
                            let modal = document.getElementById("myModalDetailDesktop");
                            modal.style.display = "flex";
                            let imgMyModalDetailDesktop = document.getElementById('imgMyModalDetailDesktop');
                            imgMyModalDetailDesktop.src = ele?.img2;
                            let imgMyModalDetailDesktop2 = document.getElementById('imgMyModalDetailDesktop2');
                            imgMyModalDetailDesktop2.src = ele?.img2;
                        }}
                        className="d-flex col-6 col-lg-3 col-md-4 justify-content-around" key={ele?.stt}>
                        <div className={"itemDetail"}>
                            <p className={"textItemDetail"}>{ele?.name + ".MTK." + ele?.stt}</p>
                            <img
                                className={"imgItemDetail"}
                                src={ele?.img1}
                                alt={"sản phẩm"}
                            />
                        </div>
                    </div>)
                })}</div>
            })}</div>

        }
        return <></>
    }

    return (<div className={"container wrapItemDetail"}>
        {renderGrid()}
        <button
            type="button" class="btn btn-secondary"
            onClick={() => {
                window.open('https://drive.google.com/drive/folders/1u0YOmrAUhE0av1wSgGV8OSxRqsZCBT_t?usp=sharing', "_blank");
            }}
            style={{ marginBottom: 10, marginTop: 10, paddingTop: 5, paddingBottom: 5, paddingLeft: 10, paddingRight: 10 }}>Xem thêm</button>
        <ModalDetailDesktop data={select} />

        <button
            className="floating-btn"

        >
            <a href={"https://zalo.me/4354315060256721375"} target={"_blank"} style={{ margin: 0, padding: 0 }}>
            <img src="/zalo_sharelogo.png" style={{width:65, height:65}}/>
            </a>
        </button>

    </div>)
}


export default DetailPK;
